import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import type { IAvatarInfo } from 'shared/ui'
import { type IReviewContact } from 'entities/Review/api/types'
import { getUserAvatarColor } from 'entities/Users/lib/getUserAvatarColor'

export class ReviewContactRow extends RowBase<IReviewContact> {
  constructor(origin: IReviewContact) {
    super(origin)
    makeObservableRowBase(this)
  }

  get comment() {
    return this.origin.comment
  }

  get createdAt() {
    return this.origin.created_at
  }

  get formattedNumber() {
    return this.origin.formatted_number
  }

  get firstName() {
    return this.origin.first_name
  }

  get lastName() {
    return this.origin.last_name
  }

  get fullName() {
    return this.origin.full_name
  }

  get rate() {
    return this.origin.rate
  }

  get shortUrlLastClickedAt() {
    return this.origin.short_url_last_clicked_at
  }

  get lastClickedAt() {
    return this.origin.last_clicked_at
  }

  get color() {
    return getUserAvatarColor(this.origin.id)
  }

  get avatarInfo(): IAvatarInfo {
    const isPhoneAbbr = !this.origin.first_name && !this.origin.last_name

    return {
      isPhoneAbbr,
      firstName: this.origin.first_name || '',
      lastName: this.origin.last_name || '',
      image: this.origin.photo_url || '',
      color: this.color,
      number: this.formattedNumber || '',
    }
  }
}
